exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProjectEvidenceButton-module__wrapper___1fO21{display:grid;gap:1rem}.ProjectEvidenceButton-module__wrapper___1fO21 .ProjectEvidenceButton-module__course-description___2Oj3X{color:#b4bac3;text-align:center;font-size:14px}.ProjectEvidenceButton-module__wrapper___1fO21 button{justify-self:center}.ProjectEvidenceButton-module__wrapper___1fO21 .ProjectEvidenceButton-module__bar___1rlfG{height:1px;width:100%;background-color:#ececec}.ProjectEvidenceButton-module__wrapper___1fO21 .ProjectEvidenceButton-module__circle-buttons___3pBqu{justify-self:end;display:grid;gap:.5rem;grid-auto-flow:column;align-items:center}", ""]);

// exports
exports.locals = {
	"wrapper": "ProjectEvidenceButton-module__wrapper___1fO21",
	"course-description": "ProjectEvidenceButton-module__course-description___2Oj3X",
	"bar": "ProjectEvidenceButton-module__bar___1rlfG",
	"circle-buttons": "ProjectEvidenceButton-module__circle-buttons___3pBqu"
};